import { Switch as HeadlessSwitch } from '@headlessui/react';

import { cn } from '@/utils/styles';

type SwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
};

export function Switch({ checked, onChange, label, disabled = false, className }: SwitchProps) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <HeadlessSwitch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={cn(
          'relative inline-flex h-6 w-11 items-center rounded-full transition-colors',
          checked ? 'bg-secondary' : 'bg-gray-200',
          disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
          'focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2'
        )}
      >
        <span
          className={cn(
            'inline-block h-4 w-4 transform rounded-full bg-white transition-transform',
            checked ? 'translate-x-6' : 'translate-x-1'
          )}
        />
      </HeadlessSwitch>
      {label && (
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>
      )}
    </div>
  );
}
